// extracted by mini-css-extract-plugin
module.exports = {"box":"cat-menu-module--box--1p5AW","menu":"cat-menu-module--menu--268et","catname":"cat-menu-module--catname--1y1Z6","catpagebar":"cat-menu-module--catpagebar--1xX_b"};